import * as React from 'react';
import { FC } from 'react';

interface RecipeFeedbackFormModel {
    recipeName: string,
    contentId: string,
}

const RecipeFeedbackForm: FC<RecipeFeedbackFormModel> = (props) => {

    const [feedbackText, setFeedbackText] = React.useState('');
    const [sendState, setSendState] = React.useState(false);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = async (e:any) => {
        e.preventDefault()
        try {
            const response = await fetch('/api/recipes/sendfeedback', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "recipeName": props.recipeName,
                    "feedbackText": feedbackText
                })
            });

            if (!response.ok) {
                throw new Error('Something went wrong');
            }

            if (response.ok) {
                setSendState(true);
                localStorage.setItem(`recipefeedback_${props.contentId}`, props.contentId);
            }
        } catch (error) {
            console.error('Fetch error:', error);
        }
    }

    React.useEffect(() => {
        const recipeFeedback = localStorage.getItem(`recipefeedback_${props.contentId}`);
        if (recipeFeedback !== null && recipeFeedback === props.contentId.toString()) {
            setSendState(true);
        }
    },[])
    
    return (
        <>
            {!sendState && (
                <form onSubmit={(e) => handleSubmit(e)}>
                    <fieldset>
                        <label className="sr-only" htmlFor="feedback">
                            Har du noen innspill, kan du skrive det her:
                        </label>
                        <textarea id="feedback" className="w-full min-h-[150px] border-2 border-brown-secondary px-4 py-3 rounded-lg mb-0" minLength={Number(10)} maxLength={Number(550)} onChange={(e) => setFeedbackText(e.target.value) }></textarea>
                        <p className={`text-xs text-right pr-1 leading-none ${feedbackText.length > 549 ? 'text-red-secondary' : '' }`}>[{feedbackText.length}/550]</p>
                        <button type="submit" className="btn-primary laptop:!rounded-lg w-full laptop:w-auto justify-center mt-6" disabled={feedbackText.length < 10 ? true : false}>
                            Send innspill
                        </button>
                    </fieldset>
                </form>
            )}

            {sendState && (
                <div className='rounded-xl bg-yellow-primary p-4 mb-5 laptop:p-6 laptop:mb-6 text-lg'>
                    Takk for ditt innspill
                </div>
            )}
        </>
    );
};
export default RecipeFeedbackForm;